export const tourText = {
  addLearners: {
    title: 'Add learners',
    description:
      'Invite learners to your workspace one by one or in bulk to start enrolling them in courses.',
  },
  filter: {
    title: 'Filter learners',
    description:
      'Narrow the list by course or other criteria to find specific learners faster.',
  },
  status: {
    title: 'Learner status',
    description:
      'Quickly see if a learner is active, inactive, or still pending invitation.',
  },
  actions: {
    title: 'Quick actions',
    description:
      'Activate, delete, or resend invitations directly from this column.',
  },
  expandRow: {
    title: 'See enrolled courses',
    description:
      'Click the arrow to expand a learner and review every course they are enrolled in along with their progress.',
  },
};
